import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PagoPage } from '../pago/pago';
import { LoginPage } from '../login/login';
import { Http } from '@angular/http';
import { ArticuloPage } from '../articulo/articulo';
import { FacturaPage } from '../factura/factura';

@IonicPage()
@Component({
  selector: 'page-carrito',
  templateUrl: 'carrito.html',
})
export class CarritoPage {
  user;
  carrito = [];
  totalPrice=0;
  titlePay;
  carritoCount;
  language = {
    pay:'',
    seeInvoice:''
  };
  constructor(public navCtrl: NavController, public navParams: NavParams, public http:Http) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.user=JSON.parse(localStorage.getItem('user')).CODIGO_USER;
    
    let params = "codigo_user="+this.user;
    this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=selectUser&"+params).subscribe((data)=>{
    this.carrito = data.json();
    })
    this.http.get("http://ebenlovequickpc.com/API/verCar.php?cl=select&codigoUser="+this.user).subscribe((data)=>{
      if(data.json().length !== 0){
        this.titlePay = this.language.pay;
        this.carritoCount = true;
      }else{
        this.titlePay = this.language.seeInvoice;
        this.carritoCount = false;
      }
    })
    setTimeout(()=>{
    this.carrito.forEach((item,index)=>{
      this.totalPrice += parseInt(item.PRECIO);
    });
    },3000);
  }
  producto(prod){
    this.navCtrl.setRoot(ArticuloPage,{prod:prod});
  }
  pagar(){
    if(localStorage.getItem("TOKEN")){
      this.http.get("http://ebenlovequickpc.com/API/verCar.php?cl=select&codigoUser="+this.user).subscribe((data)=>{
        if(this.carritoCount){
          this.navCtrl.setRoot(PagoPage,{isCarrito: true});
        }else{
          this.titlePay = this.language.seeInvoice;
          this.navCtrl.push(FacturaPage, {vista: 'carrito'});
        }
    })
      
    }else{
      this.navCtrl.push(LoginPage);
    }
    
  }
  quitarProd(prod){
    let params = "codigo_car="+prod;
    this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=delete&"+params).subscribe((data)=>{
      this.navCtrl.setRoot(CarritoPage);
    })
  }

  quitarTodos(){
    this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=deleteAll").subscribe((date)=>{
      this.navCtrl.setRoot(CarritoPage);
    })
  }
  ionViewDidLoad() {
  }



}



// WEBPACK FOOTER //
// ./src/pages/carrito/carrito.ts